module.exports = __webpack_public_path__ + "img/solaris-barres-2.cae402f8.png";